import React from "react";

const WidgetTitle = ({ title }) => (
  <h3 className="text-uppercase">
    <small>{title}</small>
  </h3>
)

export default WidgetTitle;